import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { CookieConsentControlContainer } from '../styles/LocationFilter.styles';
import { saveConsentToStorage, useGoogleConsent } from '@oneaudi/two-click';
import { DangerousElement } from '../../../components';
import { Text, ToggleSwitch, Icon, } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { FilterContext } from '../FilterContext';
import { setLocationFilterToDefaultState } from '../utils';
import { useClearAllDealerFilters } from '../FilterContextHooks';
import { useServicesContext } from '../../../context';
import { SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT, SYS_SPACE_FIXED_200, } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper, DynamicThemeProviderWrapper } from '../../utils';
import { SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK } from '@oneaudi/unified-web-alpha-common';
export const CookieConsentControl = ({ setMap }) => {
    const consent = useGoogleConsent();
    const contentText = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentControl.Content`,
        defaultMessage: '',
    });
    const toggleText = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentControl.Toggle`,
        defaultMessage: '',
    });
    const context = React.useContext(FilterContext);
    const { getConfiguration, getEnvironmentConfig } = useServicesContext();
    const clearAllDealerFilters = useClearAllDealerFilters();
    return (React.createElement(DynamicThemeProviderWrapper, null,
        React.createElement(CookieConsentControlContainer, null,
            React.createElement(StyledIcon, { name: "info-circle", size: "s" }),
            React.createElement("div", null,
                React.createElement(StyledText, { tag: "p", variant: {
                        order: '1',
                        style: 'normal',
                        type: 'copy',
                    } },
                    React.createElement(DangerousElement, { as: "p", html: contentText })),
                React.createElement(StyledToggleSwitch, { id: "toggle__with-labels", label: toggleText, labelPosition: "trailing", checked: consent, name: "toggle__with-labels", value: "toggle__with-labels", onChange: () => {
                        setMap(undefined);
                        setLocationFilterToDefaultState(getConfiguration(), getEnvironmentConfig(), clearAllDealerFilters, context, { current: { value: '' } });
                        saveConsentToStorage(false);
                    } })))));
};
export default CookieConsentControl;
const StyledToggleSwitch = styled((props) => React.createElement(ToggleSwitch, Object.assign({}, props))) `
  padding-top: ${SYS_SPACE_FIXED_200};
`;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  > p {
    margin: 0;
  }
  a {
    color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT, SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK)};
  }
`;
const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  max-width: 30px;
  color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT, SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK)};
`;
